import { Container, Card, Row, Col } from "react-bootstrap"
import { t } from '../../../../misc/utils'
import step1 from '../../../../assets/image/process-step1.svg'
import step2 from '../../../../assets/image/process-step2.svg'
import step3 from '../../../../assets/image/process-step3.svg'

const ProcessGuideComponent = ({ mobile }) => {
    return (
        <div className="tutorial">
            <div className="container-default">
            {mobile ? <b>{t.addgoods.textTitle}</b> : <p className='label'>{t.addgoods.textTitle}</p>}
            <Row>
                    <Col xs={mobile ? 12 : 6} className={mobile ? 'img-center' : 'img-center padding-vertical70' }>
                        <img src={step1} height={mobile ? 160 : "100%"}></img>
                    </Col>
                    <Col xs={mobile ? 12 : 6} className={mobile ? 'img-center padding-vertical25' : 'img-center padding-vertical70'}>
                        <ul>
                            <li>
                                <p>{t.guides.processOrder.textStep1}</p>
                            </li>                            
                        </ul>
                    </Col>
                    <Col xs={mobile ? 12 : 6} className={mobile ? 'img-center' : 'img-center padding-vertical70' }>
                        <img src={step2} height={mobile ? 160 : "100%"}></img>
                    </Col>
                    <Col xs={mobile ? 12 : 6} className={mobile ? 'img-center padding-vertical25' : 'img-center padding-vertical70'}>
                        <ul>
                            <li>
                                <p>{t.guides.processOrder.textStep2_1}</p>
                            </li>                            
                            <li>
                                <p>{t.guides.processOrder.textStep2_2}</p>
                            </li>                            
                        </ul>
                    </Col>
                    <Col xs={mobile ? 12 : 6} className={mobile ? 'img-center' : 'img-center padding-vertical70' }>
                        <img src={step3} height={mobile ? 160 : "100%"}></img>
                    </Col>
                    <Col xs={mobile ? 12 : 6} className={mobile ? 'img-center padding-vertical25' : 'img-center padding-vertical70'}>
                        <ul>
                            <li>
                                <p>{t.guides.processOrder.textStep3}</p>
                            </li>                                                                             
                        </ul>
                    </Col>                    
                </Row>
            </div>
        </div>
    )
}

export default ProcessGuideComponent